/**
 * Generic carousel for portrait thumbnail ratio view
 *
 * Doc refer to `development/js/components/landscapeCarousel.js`
 */

import 'components/carousels/JsCarousel.js';
import { SwiperCarouselPortraitBreakpoints } from 'components/settings/BreakpointSettings';

export default function (customOptions = {}) {
    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');

    let defaultOptions = {
        responsive: SwiperCarouselPortraitBreakpoints,
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);

    wrapper.JsCarousel(endOptions);
    return wrapper;
}
